import React from 'react';
import '../template-file-css/document-file-template.css';


export const CS_AdditionalInformation = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='CS_AdditionalInformation' className='file-pdf-document'>
            <div className='file-template'>


                <p className='w-750'>
                    <strong>Additional information for our leadership team that should not go to the state(come to us separate from the Progress Report Document) and should be captured during every staff and client meeting:</strong>
                </p>
                <ul>
                    <li>
                        which service did you provide: meeting, site visit, interview, DBHDD (these could be check boxes - all that apply).
                    </li>
                    <li>
                        Trinity, I do believe you capture the next section already....number of hours, the start date and time of the meeting or whether the meeting was a "no show" so you may disregard this part of the screenshot.
                    </li>
                    <li>
                        List a minimum of three companies applied for: company name, position, street and city, phone number. Please enter NA or select upload if you choose to upload the file with this information or if the clientHas an interview.
                    </li>
                    <li>
                        List major barriers/ disability (this is something that can be shared with the employer before the interview only if necessary and helpful)
                    </li>
                    <li>
                        does the client have transportation to and from the interview, checkboxes yes or no
                    </li>
                    <li>
                        earliest time can report to a job
                    </li>
                    <li>
                        latest time can't stay on a job
                    </li>
                    <li>
                        days of the week the client cannot work
                    </li>
                    <li>
                        are you documenting on a working client or non-working client, checkboxes working or non working
                    </li>
                </ul>
                <p className='w-750'>
                    <span className='eleHeader'>Which Service did you provide?</span><span className='small'> Employment Coordination $18.00/hour (3 to 4 hours max unless with permission - Mtg/sitevist/interview or DBHDD client)</span>
                    <textarea id="txtService" name="txtService" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>ENTER NUMBER OF HOURS USED TO PROVIDE SERVICES FOR CLIENT In 15 MINUTE INCREMENTS (minus travel time) - *Not to Exceed 3 hours per client per week. If more is needed please contact Support for written permission.</span>
                    <input type="text" id="txtEnterNumber" name="txtEnterNumber" placeholder="Type a number" className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Meeting Start Time</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="time" id="txtTimeIn_1" name="txtTimeIn_1" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Check here if client is a "NO SHOW" (One hour's Pay (total) will be paid for Client No Shows)</span>
                    <input type="checkbox" name="chkClinical" id="chkClinical" className='add-only' value="Clinical" /> Client did not show up or call to reschedule
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Please list companies applied for with client. Should be a minimum of 3 or 4 </span><span className='small'> (Please include the COMPANY NAME, THE POSITION, THE STREET AND CITY and PHONE NUMBER)</span>
                    <textarea id="txtCompanies" name="txtCompanies" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Enter NA if you opt to upload Job Tracking Form below (also type "SEE ATTACHED"), if client was a "no show," had an interview or if the client is a working client.</span>
                    <textarea id="txtJobTracking" name="txtJobTracking" className="add-only"></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>List client Major Barrier/Disability </span><span className='small'>(This is something that can be shared with employer before the interview if only if necessary and helpful)</span>
                    <input type="text" id="txtMajorBarrier" name="txtMajorBarrier" className='add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>Check box confirming whether or not client has transportation to and from interviews or a job</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkTransportation_1" id="chkTransportation_1" className='add-only' value="Transportation_1" /> Yes
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkTransportation_2" id="chkTransportation_2" className='add-only' value="Transportation_2" /> No
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkTransportation_3" id="chkTransportation_3" className='add-only' value="Transportation_3" /> Working on it
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>earliest time client can report to a job</span></td>
                        <td className='w-375'><span className='eleHeader'>latest time client can stay on a job</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="time" id="txtTimeIn_7" name="txtTimeIn_7" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="time" id="txtTimeIn_8" name="txtTimeIn_8" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>List days of week client cannot work or type NA</span>
                    <input type="text" id="txtWeekClient" name="txtWeekClient" className='add-only' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Are you documenting on a Working Client or Non-Working Client. Please check appropriate box below.</span>
                    <input type="radio" id="rbNonWorking_Yes" name="rbNonWorking" className='add-only' value="1" /> Working Client &nbsp;&nbsp;
                    <input type="radio" id="rbNonWorking_No" name="rbNonWorking" className='add-only' value="0" /> Non-Working Client
                </p>






            </div>
        </form>

    )
}